import cookie from 'cookie-utils-js';
import { getAppInfo } from '@/api/app';
import { capitalize } from '@/utils/util';

const resetState = {
	themeColor: '#8C33DE',
	virtualCurrencyUnit: 'Gems',
	appid: '',
	redirectURL: ''
};

const actions = {
	async updateAppInfo({ commit, state, rootState }, payload) {
		const appid = state.appid;
    const token = rootState.user.userToken;

		if (!token || !appid) {
			dispatch('resetAppState');
			return;
		}

		try {
			const res = await getAppInfo({
        appid,
        token
      });

			if (res.code === 0) {
				commit('UPDATE_APP_INFO', {
					appname: res.data.appname,
					themeColor: res.data.app_color.theme_color,
					virtualCurrencyUnit: capitalize(res.data.virtual_currency_unit),
				});
				return;
			}
		}
		catch(err) {
			console.log(err);
		}

		dispatch('resetAppState')
	},

	async updateAppBaseInfo({ commit, state, rootState }, payload) {
		commit('UPDATE_APP_BASE_INFO', {
			appid: payload.appid,
			redirectURL: payload.redirectURL
		});
	},

	async resetAppState({ commit, state, rootState }, payload) {
		commit('UPDATE_USER_INFO', {
			...resetState
		});
	},
}

export default actions;
